import { createApp } from "vue";
import "@/applibs/http.js";

// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.min.js";
// import "./assets/css/responsive.css";

import router from "./router";
import store from "./store";
// import "aos/dist/aos.css";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import App from "./App.vue";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import VueIframe from "vue-iframes";

// import VCalendar from "v-calendar";

import VueSocketIO from "vue-3-socket.io";
// import SocketIO from 'vue-3-socket.io';
import Cookies from "js-cookie";

// Remove the legacy JS-readable jwt cookie. The API now sets jwt as HttpOnly.
Cookies.remove("jwt");

import Notifications from "@kyvg/vue3-notification";
import VueNumberFormat from "vue-number-format";

import mitt from "mitt";
import clearZero from "./directives/clearZero";
const emitter = mitt();

library.add(fas, far, fab);

const app = createApp(App);

app.config.globalProperties.emitter = emitter;
app.directive("clear-zero", clearZero);

app.use(Toast, {
  transition: "Vue-Toastification__fade",
  maxToasts: 10,
  newestOnTop: true,
});
app.component("fa", FontAwesomeIcon);

// karena semua yang ada pada .env adalah string, kita harus convert dulu
var socketio_debug = true;
if (process.env.VUE_APP_SOCKETIO_DEBUG == "true") {
  socketio_debug = true;
} else {
  socketio_debug = false;
}

app.use(store);
app.use(router);
app.use(VueIframe);
// app.use(VCalendar);
app.use(VueNumberFormat, { prefix: "", decimal: ",", thousand: "." });
app.use(
  new VueSocketIO({
    debug: socketio_debug,
    // connection: SocketIO(process.env.VUE_APP_WS)
    connection: process.env.VUE_APP_WS,
    options: {
      transports: ["websocket", "polling"],
      reconnection: true,
      upgrade: true,
      rememberUpgrade: true,
      // HttpOnly jwt (Domain=.pegasusexchange.id) must reach pgx-ws.
      withCredentials: true,
      query: {
        token: Cookies.get("jwt") || "",
      },
    },
  })
);
app.use(Notifications);
app.mount("#app");

function pgxSocketAuthenticate(explicitToken) {
  var token = explicitToken || Cookies.get("jwt");
  var socket = app.config.globalProperties.$socket;
  if (socket && token) {
    socket.emit("authenticate", { token: token });
  }
}

app.config.globalProperties.pgxSocketAuthenticate = pgxSocketAuthenticate;

// Listener global: aktif di semua halaman (tidak bergantung pada mixin komponen)
var socket = app.config.globalProperties.$socket;
if (socket) {
  socket.on("connect", function () {
    // PERHATIAN: JANGAN DI COMMENT LOG INI KARENA DI PRODUCTION AKAN MENYEBABKAN ERROR
    console.log("socket to CBC connected");
    pgxSocketAuthenticate();
  });

  socket.on("disconnect", function () {
    console.log("socket disconnected - global");
  });
}
